import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { AbpModule } from '../../node_modules/abp-ng2-module/dist/src/abp.module';
import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';



import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import {
    
} from '@angular/material';
import { AppSessionService } from './session/app-session.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { AppAuthService } from './auth/app-auth.service';
import { SubheaderService } from '../app/core/_base/layout';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { CartService } from '@app/views/pages/transpop/cart1/cart.service';
import { DestatinationAddressService } from '@app/views/pages/transpop/cart1/destatination-address.service';

@NgModule({
    imports: [

        
    CommonModule,
        //AbpModule,
        RouterModule,
        NgxPaginationModule,
       
    ],
    declarations: [
        
        
    ],
    exports: [
    
       
        //CdkTableModule,
        //CdkTreeModule,
        //DragDropModule,
       
        //ScrollingModule,
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                //AppUrlService,
                AppAuthService,
                AppRouteGuard,
                SubheaderService,
                CartService,
                DestatinationAddressService,
                GlobalErrorHandlerService
            ]
        };
    }
}
